module.exports = __webpack_public_path__ + "static/img/bjpknum.5d75b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bjpknum.png
// module id = t7Eb
// module chunks = 7